import React, { useState, useCallback } from 'react';
import { Maximize, Minimize } from 'lucide-react';
import './examHeader.scss';
const ExamHeader = ({ examTitle, timeRemaining }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  const toggleFullScreen = useCallback(() => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen()
        .then(() => setIsFullScreen(true))
        .catch(err => console.error(`Error attempting to enable fullscreen: ${err.message}`));
    } else {
      document.exitFullscreen?.()
        .then(() => setIsFullScreen(false))
        .catch(err => console.error(`Error attempting to exit fullscreen: ${err.message}`));
    }
  }, []);

  return (
    <header className="exam-header">
      <div className="exam-title">{examTitle?.mockTestId?.title || ''}</div>
      <div className="exam-info">
        <div className="time-box">
          <span className="label">Section Time</span>
          <div className="time">{timeRemaining}</div>
        </div>
        <button className="fullscreen-btn" onClick={toggleFullScreen}>
          {isFullScreen ? (
            <>
              <Minimize className="icon" />
              <span className="text full">Exit Full Screen</span>
              <span className="text short">Exit</span>
            </>
          ) : (
            <>
              <Maximize className="icon" />
              <span className="text full">Enter Full Screen</span>
              <span className="text short">Full</span>
            </>
          )}
        </button>
      </div>
    </header>
  );
};

export default ExamHeader;
